import { useMemo } from "react";

const getPDFUrl = (raw: string) => {
	const pdfBinary = atob(raw);
	const pdfArray = new Uint8Array(pdfBinary.length);

	for (let i = 0; i < pdfBinary.length; i += 1) {
		pdfArray[i] = pdfBinary.charCodeAt(i);
	}
	const pdfBlob = new Blob([pdfArray], { type: "application/pdf" });
	return encodeURIComponent(URL.createObjectURL(pdfBlob));
};

type Props = {
	pdfData: string;
};

export const PdfViewer = ({ pdfData }: Props) => {
	const pdfUrl = useMemo(() => getPDFUrl(pdfData), [pdfData]);

	return (
		<div className="tablet:min-h-[70vh] flex max-h-full min-h-[60vh] flex-col">
			<iframe
				className="grow"
				title="PDF"
				src={`/pdf-js/web/viewer.html?file=${pdfUrl}`}
				width="100%"
				height="100%"
			/>
		</div>
	);
};
